import http from "../../services/httpService";


export const getAuthFromRefresh = async (dataCenter: string, token: string) => await http.get(`/authrefresh?dc=${dataCenter}&refresh=${token}`);
export const getAuthToken = async (dataCenter: string, authCode: string) => await http.get(`/auth?dc=${dataCenter}&code=${authCode}`);
export const getAuthProfile = async (dataCenter: string, token: string) => await http.get(`/profile?dc=${dataCenter}`, {headers: {'Authorization': 'Bearer ' + token}});
